import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {Standard} from 'app/models/standard.model';
import {MultiQuestions} from 'app/models/multi-questions';
import {StepTestingService} from './step-testing.service';
import {StepsControllerService} from 'app/services/steps-controller.service';
import {AdminService} from 'app/services/admin.service';
import {StandardQuestionDraft, standardQuestionsFromDraft} from 'app/services/standard-question-draft';
import {isStandardVersionConflict, savedStandardVersion} from 'app/services/standard-version';

@Component({
  selector: 'app-step-create-testing',
  templateUrl: './step-create-testing.component.html',
  styleUrls: ['./step-create-testing.component.css']
})
export class StepCreateTestingComponent implements OnInit, OnDestroy {
  @Output() standardReloaded = new EventEmitter<Standard>();
  disSaveQBtn = false;
  isValidTempStnd = true;
  showSaveBtn = true;
  versionConflict = false;
  saveFailed = false;
  reloadFailed = false;
  standard: Standard;
  private sourceStandard: Standard;
  private sourceVersion: number;
  private readonly destroyed$ = new Subject<void>();

  constructor(public stepTestingService: StepTestingService,
              public stepsControllerService: StepsControllerService,
              public adminService: AdminService) {}

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.stepTestingService.clearQuestions();
  }

  ngOnInit(): void {
    this.showSaveBtn = this.stepsControllerService.getTempParrentID() === null;
    this.sourceStandard = this.stepsControllerService.getCurrentStandard();
    this.sourceVersion = this.sourceStandard && this.sourceStandard.version;
    this.standard = this.sourceStandard && Object.assign({}, this.sourceStandard);
    if (this.showSaveBtn && this.standard && !this.stepTestingService.questionList.length) {
      this.stepTestingService.addExistingQuestuins(this.standard.englishQuestions || [], this.standard.russianQuestions || []);
    }
  }

  deleteQuestionFromList(key): void {
    if (!this.disSaveQBtn) { this.stepTestingService.deleteQuestionFromList(key); }
  }

  addQuestionToList(): void {
    if (!this.disSaveQBtn) { this.stepTestingService.addQuestionToList(); }
  }

  addQuestionToStandardTemp(): void {
    if (this.disSaveQBtn || this.versionConflict || this.saveFailed) { return; }
    this.isValidTempStnd = this.stepTestingService.isQuestionsValid(this.stepsControllerService.getLocalUserLanguage());
    if (!this.isValidTempStnd || !this.stepTestingService.questionList.length) { return; }
    this.disSaveQBtn = true;
    this.saveFailed = false;
    const questions = standardQuestionsFromDraft(this.stepTestingService.questionList);
    this.adminService.setTempQuestionsForStandard(this.standard, questions).takeUntil(this.destroyed$)
      .subscribe(response => this.acceptQuestions(response), error => this.rejectSave(error));
  }

  private acceptQuestions(response: HttpResponse<MultiQuestions>): void {
    this.disSaveQBtn = false;
    if (this.sourceStandard.version !== this.sourceVersion) { return; }
    this.sourceStandard.version = this.standard.version;
    this.sourceVersion = this.standard.version;
    this.sourceStandard.russianQuestions = response.body.russian;
    this.sourceStandard.englishQuestions = response.body.english;
  }

  private rejectSave(error: HttpErrorResponse): void {
    this.disSaveQBtn = false;
    this.versionConflict = isStandardVersionConflict(error);
    this.saveFailed = !this.versionConflict;
  }

  reloadStandard(): void {
    if (this.disSaveQBtn || (!this.versionConflict && !this.saveFailed)) { return; }
    this.disSaveQBtn = true;
    this.reloadFailed = false;
    this.adminService.getStandard(this.standard.id).takeUntil(this.destroyed$).subscribe(response => {
      const standard = response.body as Standard;
      const version = savedStandardVersion(response);
      if (version != null) { standard.version = version; }
      this.standard = Object.assign({}, standard);
      this.sourceStandard = standard;
      this.sourceVersion = standard.version;
      this.disSaveQBtn = false;
      this.versionConflict = false;
      this.saveFailed = false;
      this.standardReloaded.emit(standard);
    }, () => {
      this.disSaveQBtn = false;
      this.reloadFailed = true;
    });
  }

  copyQuestion(index): void {
    if (!this.disSaveQBtn) { this.stepTestingService.addQuestionToListCopy(index); }
  }

  trackQuestion(index: number, question: StandardQuestionDraft): StandardQuestionDraft {
    return question;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-six/step-create-testing/step-create-testing.component.ts